import type React from "react";
import { useEffect, useRef } from "react";

interface SanitizedHtmlProps {
  html: string;
  className?: string;
}

export const SanitizedHtml: React.FC<SanitizedHtmlProps> = ({
  html,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = html;
    }
  }, [html]);

  return <div ref={ref} className={className} />;
};
